import { Location } from '@angular/common'
import { Component, OnInit } from '@angular/core';
import { IExamPenalty } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-penalty',
  templateUrl: './exam-penalty.component.html',
  styleUrls: ['./exam-penalty.component.scss']
})
export class ExamPenaltyComponent implements OnInit {

  modelError = "";
  constructor(private examService: ExamService, private snackBar: SnackbarService, private location: Location) { }

  examPenalty: IExamPenalty = {
    id: 0,
    detectFocusLoss: false,
    permissibleDurationOfLoss: 0,
    maxAllowedFocusLossCount: 0,
    focusLossAction: '',
    focussLossTimePenalty: 0,
    focussLossRestartActionLimit: 0,
    // concurrentLoginPenalty: ''
  }

  async ngOnInit() {
    this.examPenalty = await this.examService.getExamPenalties() as IExamPenalty;
  }

  async saveExam() {
    const res = await this.examService.updateExamPenalties(this.examPenalty);
    if (res) {
      this.snackBar.success('EXAMINATION UPDATED!!');
    }
    this.location.back();
  }

}
